<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="scroll-box">
        <div class="progress"></div>
        <div class="gift-box">
          <div
            v-for="(item, key) in giftData.list"
            :key="key"
            class="gift-item"
          >
            <div class="top">
              <span>预约人数</span>
              <span>{{ item.name }}</span>
            </div>
            <div class="gift" :class="{ finish: item.finish }">
              <div class="image">
                <img :src="getGiftImg(item.icon)" />
              </div>
              <div class="name">{{ item.rewardName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-tips">左右滑动查看更多</div>
      <div class="bottom">
        <div class="reward-btn" @click="openReserveDialog"></div>
        <!-- <div class="rule" @click="openRuleDialog">活动规则</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import reservationMixins from '@/mixins/home/reservationMixins.js'

export default {
  name: 'MobileHomeReservation',
  mixins: [reservationMixins],
}
</script>

<style lang="scss" scoped>
.module {
  height: 171.2vw;

  &__title {
    background-position: center -23.2vw;
  }

  &__content {
    width: 100%;
    height: 117.6vw;
  }
}

.scroll-box {
  position: relative;
  margin-top: 4.8vw;
  width: 100%;
  height: 83.6vw;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.progress {
  position: absolute;
  top: 4.666666vw;
  width: 151.866666vw;
  height: 9.466666vw;
  background: url('~@/assets/img/mobile/reservation_bg.png') no-repeat;
  background-size: 100% 100%;
  background-position: center;
}

.gift-box {
  position: absolute;
  top: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 3.666666vw;
  width: 132.766666vw;
}

.gift-item {
  display: flex;
  flex-direction: column;
  width: 26.666666vw;
  height: 83.4vw;

  .top {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Noto Serif SC;
    font-weight: bold;

    span:first-child {
      line-height: 3.2vw;
      font-size: 3.2vw;
      color: #453932;
    }

    span:last-child {
      font-size: 4vw;
      color: #388176;
    }
  }

  .gift {
    position: relative;
    width: 100%;
    height: 69.866666vw;
    background: url('~@/assets/img/mobile/gift_bg1.png') no-repeat;
    background-position: 0;
    background-size: 53.333333vw;

    &.finish {
      background-position: -26.666666vw;
    }

    .image {
      position: absolute;
      top: 13.5vw;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      width: 15.2vw;
      height: 15.2vw;

      img {
        width: 100%;
      }
    }

    .name {
      position: absolute;
      top: 34vw;
      width: 100%;
      text-align: center;
      font-size: 2.666666vw;
      color: #613811;
      white-space: pre-wrap;
    }
  }
}

.scroll-tips {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4.4vw 0 5.6vw ;
  width: 100%;
  height: 5.2vw;
  font-size: 3.466666vw;
  color: #584c45;    

  &:before,
  &:after {
    content: '';
    width: 14.666666vw;
    height: 5.2vw;
    background: url('~@/assets/img/mobile/scroll_arrow.png') no-repeat;
    background-size: 100%;
  }

  &:before {
    background-position: 0 0;
  }
  &:after {
    background-position: 0 -5.2vw;
  }
}

.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .rule {
    margin-top: 5.6vw;
    font-size: 3.466666vw;
    color: #3479a5;
    
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: .133333vw;
      background: #3479a5;
    }
  }
}

.reward-btn {
  width: 44.133333vw;
  height: 10.133333vw;
  background: url('~@/assets/img/mobile/reward_btn1.png') no-repeat;
  background-size: 100%;
}
</style>